var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.aboutPage != null)?_c('div',{staticClass:"about-main-page"},[_c('aboutUs_section'),_c('history_section'),_c('choose_section'),_c('mission_section'),_c('div',{staticClass:"corp-info-container"},[_c('promoNews'),_c('promoProjects'),_c('formPage',{staticClass:"form-page-about"})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }